import required from '../../../../form/field-validation/required';
import validEmail from '../../../../form/field-validation/valid-email';

const fieldName = 'email';

export default {
  name: 'email',
  label: 'email.address',
  required: true,
  validate: [required(fieldName), validEmail()],
  autoComplete: 'email',
  type: 'email',
};
